import { plugin, debug, type ButtonProps } from 'light-component';
import * as Base from '@base';
import { Icons, IconNames, t } from '@common';
import type { CSSProperties, ReactElement } from 'react';

export function WidgetButton(props: ButtonProps): ReactElement {
  debug.widget('dashboard button', props);

  const style: CSSProperties = {
    backgroundColor: '#e44134',
    ...props.style
  };

  return (
    <div className={`${props.className ?? ''} draggable`}>
      <Base.Button
        type='primary'
        style={style}
        icon={props.icon != null ? <Icons name={props.icon as IconNames} /> : null}
        onClick={props.onClick}
      >
        {t(props.title ?? '')}
      </Base.Button>
    </div>
  );
}

plugin.register({ kind: 'widget', type: 'button', component: WidgetButton });
